import { FulfillmentGroupData } from "@redotech/redo-model/fulfillments/fulfillment-group";
import { RedoModal } from "@redotech/redo-web/arbiter-components/modal/redo-modal";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import {
  PinVerificationType,
  usePinVerification,
} from "../../common/pin-verification-context";

export const MergedPackingSlipScannedModal = memo(
  function MergedPackingSlipScannedModal({
    onContinue,
    onCancel,
    open,
    fulfillmentGroupData,
  }: {
    onContinue: () => void;
    onCancel: () => void;
    open: boolean;
    fulfillmentGroupData?: FulfillmentGroupData;
  }) {
    const { executeWithPinCheck } = usePinVerification();

    const handleContinue = async () => {
      executeWithPinCheck(
        () => {
          onContinue();
        },
        { type: PinVerificationType.ContinueToScanPageOnOutdatedPackingSlip },
      );
    };

    if (!fulfillmentGroupData) {
      return null;
    }

    return (
      <RedoModal
        isOpen={open}
        onModalCloseRequested={onCancel}
        primaryButton={{ text: "Continue", onClick: handleContinue }}
        secondaryButton={{ text: "Cancel", onClick: onCancel }}
        title="Merged packing slip scanned"
      >
        <Text>
          You scanned a packing slip for an order that has since been merged.
          The packing slip likely does not contain all of the relevent items for
          the merged order. Are you sure you want to proceed to the merged
          order?
        </Text>
      </RedoModal>
    );
  },
);
